// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar_tab .n-tab-pane[data-v-7165c4ac]{display:none !important}`, "",{"version":3,"sources":["webpack://./src/components/calendar/ToolBar.vue"],"names":[],"mappings":"AAEE,0CACE,uBAAA","sourcesContent":["\n.toolbar_tab {\n  .n-tab-pane {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
